module.exports = __webpack_public_path__ + "static/img/m9.5542fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/mobile/m9.png
// module id = /IGE
// module chunks = 12